export default "__VITE_ASSET__UG_DFLAW__"